export default {
    namespaced: true,
    state: () => ({
        items: [],
        newPoint: 0,
        scavengerHuntFound: false,

        isLoading: false,
        isStampCollectable: false,
    }),
    getters: {
        stampItems(state){
            // return _.uniqBy(state.items, (item) => {
            //     return JSON.stringify(_.pick(item, ["user", "title", "room"]));
            // });
            const jukeboxRegex = /^Jukebox \d+ points$/;
            const excludedItems = state.items.filter(item => jukeboxRegex.test(item.title));
            const filteredItems = state.items.filter(item => !jukeboxRegex.test(item.title));

            const uniqueFiltered = _.uniqBy(filteredItems, (item) => {
                return JSON.stringify(_.pick(item, ["user", "title", "room"]));
            });

            return [...uniqueFiltered, ...excludedItems];
        },
        currentPoints(state, getters){
            return _.sumBy(getters.stampItems, "point");
        },
    },
    actions: {
        SOCKET_onGlobalTriggerLiveStreamStamp({ state, rootState, commit, dispatch }, res){
            console.log('SOCKET_onGlobalTriggerLiveStreamStamp ->', res);

            const isCurrentRoom = (res.item.room == "Test Room" || rootState.auth.currentRoom == "Test Room")? res.item.room == rootState.auth.currentRoom : true;
            if(res.item && res.item.title && isCurrentRoom && rootState.auth.isOpenLiveStream){
                dispatch("onSubmitLiveStamp", _.pick(res.item, ["room", "title"]));
            }
        },
        SOCKET_onGlobalUpdateStampCollectable({ commit }, res){
            console.log('SOCKET_onGlobalUpdateStampCollectable ->', res);
            commit("setIsStampCollectable", res.item);
        },
        onSubmitStamp({ state, rootState, commit }, data){
            if(state.isStampCollectable && !state.isLoading){
                commit("setIsLoading", true);
                
                const isExists = !!_.find(state.items, { title: data.title, room: data.room });
                if(isExists) return commit("setIsLoading", false);

                // use for stg scavenger hunt testing
                // if(data.title.includes("Scavenger Hunt")){
                //     commit("setScavengerHuntFound", true);
                //     commit("addItem", { ...data, point: 2 });
                //     commit("setIsLoading", false);
                //     return;
                // }

                const tokenHeader = {
                    headers: {
                        authorization: `Bearer ${ rootState.auth?.user?.token }`
                    }
                };

                this.$axios.$post("/stamp", data, tokenHeader).then((res) => {
                    console.log("submitStampCallback", res);
                    if(res.is_accepted){
                        if(data.title.includes("Scavenger Hunt")){
                            commit("setScavengerHuntFound", true);
                        }
        
                        commit("addItem", res.item);
                        commit("setNewPoint", res.item?.point);
                    }
                    commit("setIsLoading", false);
                }).catch((err) => {
                    console.error("submitStampError", err);
                    commit("setIsLoading", false);
                    if(err?.response?.data?.message == "Please refresh the page first"){
                        return this.$swal({
                            icon: "info",
                            title: "Please refresh the page first",
                            confirmButtonText: "Refresh Now",
                        }).then((result) => {
                            window.location.reload();
                        })
                    }
                    this.$toast.global.myerror(`Failed to collect stamp`);
                    // return this.showErrorSwal(err);
                });
            }
        },
        onSubmitLiveStamp({ state, rootState, commit }, data){
            if(state.isStampCollectable && !state.isLoading){
                commit("setIsLoading", true);
                
                const isExists = !!_.find(state.items, { title: data.title, room: data.room });
                if(isExists) return commit("setIsLoading", false);

                // Promise.all(
                //     Array.from(Array(200).keys()).map(() => {
                //         this._vm.$socket.emit("addUserLiveStamp", data, res => {
                //             if(res.item){
                //                 console.log("submitLiveStampCallback", res);
                //                 commit("addItem", res.item);
                //                 commit("setNewPoint", res.item?.point);
                //             }else{
                //                 console.error("submitLiveStampError", res);
                //             }
                //             commit("setIsLoading", false);
                //         });
                //     })
                // )

                const randomSecond = Math.floor(Math.random() * 3);
                setTimeout(() => {
                    this._vm.$socket.emit("addUserLiveStamp", data, res => {
                        if(res.item){
                            console.log("submitLiveStampCallback", res);
                            commit("addItem", res.item);
                            commit("setNewPoint", res.item?.point);
                        }else{
                            console.error("submitLiveStampError", res);
                        }
                        commit("setIsLoading", false);
                    });
                }, randomSecond * 1000);
            }
        },
    },
    mutations: {
        setItems(state, items){
            state.items = items;
        },
        addItem(state, item){
            if(item){
                state.items.push(item);
                state.newPoint = item.point;
                this.$toast.global.mysuccess(`Collected ${ item?.point } point(s)`);
            }
        },
        setNewPoint(state, item){
            state.newPoint = item;
        },
        setScavengerHuntFound(state, item){
            state.scavengerHuntFound = item;
        },
        setIsLoading(state, item){
            state.isLoading = item;
        },
        setIsStampCollectable(state, item){
            state.isStampCollectable = item;
        }
    }
}